import { callAPI } from "services/api";
import {
  BookingEnquiryRequest,
  MessageRequest,
  SupportRequest,
  SupportRequestType,
} from "services/entities/contact";
import Cookies from "js-cookie";

export function getTrackingID() {
  return Cookies.get("hubspotutk");
}

export async function sendMessage(request: MessageRequest): Promise<void> {
  const trackingID = getTrackingID();
  const { phoneNumber, ...requestProps } = request;
  const requestData = {
    phone_number: phoneNumber,
    tracking_id: trackingID,
    ...requestProps,
  };
  await callAPI("/contact/message/", "POST", requestData);
}

export async function logEnquiry(): Promise<void> {
  const trackingID = getTrackingID();
  await callAPI("/contact/enquiry/", "POST", { tracking_id: trackingID }, true);
}

export async function logBookingEnquiry(
  request: BookingEnquiryRequest
): Promise<void> {
  const trackingID = getTrackingID();
  const formData = new FormData();
  if (trackingID) {
    formData.append("tracking_id", trackingID);
  }
  formData.append("space", request.space);
  let index = 0;
  if (request.times) {
    for (const t of request.times) {
      formData.append(`times[${index}]start`, t.start.format());
      formData.append(`times[${index}]end`, t.end.format());
      index++;
    }
  } 
  if (request.user) {
    formData.append("first_name", request.user.firstName);
    formData.append("last_name", request.user.lastName);
    formData.append("email", request.user.email);
    formData.append("phone_number", request.user.phone);
    formData.append("company_name", request.user.companyName);
  }
  await callAPI("/contact/booking-enquiry/", "POST", formData, !request.user);
}

export async function requestSupport(request: SupportRequest): Promise<void> {
  const trackingID = getTrackingID();
  const formData = new FormData();
  if (trackingID) {
    formData.append("tracking_id", trackingID);
  }
  formData.append("first_name", request.firstName);
  formData.append("last_name", request.lastName || "");
  formData.append("email", request.email);
  formData.append("phone_number", request.phoneNumber || "");
  switch (request.type) {
    case SupportRequestType.Designing:
      formData.append("type", "designing");
      break;
    case SupportRequestType.Booking:
      formData.append("type", "booking");
      break;
    default:
    case SupportRequestType.Other:
      formData.append("type", "other");
      break;
  }
  formData.append("summary", request.summary);
  formData.append("description", request.description);
  if (request.attachment) {
    formData.append("attachment", request.attachment);
  }
  await callAPI("/contact/support/", "POST", formData);
}
